import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ModalBasicLayout from "./ModalBasicLayout";
import CreditsUsageBreakdownTables from "./CreditsUsageBreakdownTables";
import CreditsUsageDetailedSuperAdminContent from "./CreditsUsageDetailedSuperAdminContent";
import { useTranslationApp } from "../../lib/i18next";
import { useDispatchApp } from "../../lib/redux";
import { getPathDatabaseByRole } from "../../actions/auth";
import { startGetDetailedCreditsUsage } from "../../actions/payments";
import { SUPER_ADMIN_ROLE } from "../../utils/constants";
import {
  MODAL_CREDITS_USAGE_DETAILED_TITLE,
  MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL,
  MODAL_CREDITS_USAGE_DETAILED_PERIOD,
} from "../../i18n/keysTranslations";

const ModalCreditsUsageDetailed = ({
  modalOpen = false,
  onCloseModal = () => {},
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const { role } = dispatch(getPathDatabaseByRole());
  const isSuperAdmin = role === SUPER_ADMIN_ROLE;

  const [loading, setLoading] = useState(false);
  const [byAdvertiser, setByAdvertiser] = useState([]);
  const [byUser, setByUser] = useState([]);
  const [period, setPeriod] = useState(null);

  useEffect(() => {
    if (!modalOpen || isSuperAdmin) return;

    let isCancelled = false;

    const onFetchData = async () => {
      setLoading(true);
      setByAdvertiser([]);
      setByUser([]);
      setPeriod(null);

      const result = await dispatch(startGetDetailedCreditsUsage());

      if (isCancelled) {
        return;
      }

      if (result?.ok) {
        setByAdvertiser(result.byAdvertiser ?? []);
        setByUser(result.byUser ?? []);
        setPeriod(result.period);
      }
      setLoading(false);
    };

    onFetchData();

    return () => {
      isCancelled = true;
    };
  }, [modalOpen, dispatch, isSuperAdmin]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(MODAL_CREDITS_USAGE_DETAILED_TITLE)}
      ariaLabel={t(MODAL_CREDITS_USAGE_DETAILED_ARIA_LABEL)}
      maxWidth={isSuperAdmin ? "md" : "sm"}
      fullWidth
    >
      {isSuperAdmin ? (
        <CreditsUsageDetailedSuperAdminContent modalOpen={modalOpen} />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pb: 1 }}>
          {period && (
            <Typography variant="body2" color="text.secondary">
              {t(MODAL_CREDITS_USAGE_DETAILED_PERIOD, {
                from: period.from,
                to: period.to,
              })}
            </Typography>
          )}

          <CreditsUsageBreakdownTables
            loading={loading}
            byAdvertiser={byAdvertiser}
            byUser={byUser}
          />
        </Box>
      )}
    </ModalBasicLayout>
  );
};

export default ModalCreditsUsageDetailed;
